import script from "./RoomDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomDisplay.vue?vue&type=script&setup=true&lang=js"

import "./RoomDisplay.vue?vue&type=style&index=0&id=5a6a5970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6a5970"]])

export default __exports__